var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 1.53345 14.4665 0 8 6.46655 1.53345 0 0 1.53345 6.46655 8 0 14.4665 1.53345 16 8 9.53345 14.4665 16 16 14.4665 9.53345 8 16 1.53345Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close;

Close.default = Close;
